// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Employee Leave Tracker Styles */
.empleavetracker-container {
  width: 100%;
  margin: 20px auto;
  font-family: Arial, sans-serif;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.empleavetracker-header {
  background-color: white;
  color: black;
  text-align: left;
  font-size: 20px;
  padding: 10px;
  font-weight: bold;
}

.empleavetracker-table {
  width: 100%;
  border-collapse: collapse;
}

.empleavetracker-table th,
.empleavetracker-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: center;
  
}
@media (min-width: 1200px) {
  .empleavetracker-container {
    max-width: 1100px; /* Limit max width on larger screens */
  }
}
.empleavetracker-table th {
  background-color: #bebdbd;
  color: black;
}

.empleavetracker-table tbody tr {
  background-color: white;
}

.empleavetracker-status-approved {
  background-color: #d7f2ce;
  color: #155724;

  text-align: center;
  padding: 6px 6px;
 
 display: block;
  border-radius: 20px;
  min-width: 80px;
}

.empleavetracker-status-rejected {
  background-color: #ffe5d2;
  color: #721c24;
  text-align: center;
  padding: 6px 6px;
 
 display: block;
  border-radius: 20px;
  min-width: 80px;
}

.empleavetracker-status-pending {
  background-color: #fff3cd;
  color: #856404;
  text-align: center;
  padding: 6px 6px;
 
 display: block;
  border-radius: 20px;
  min-width: 80px;
}

.empleavetracker-status-default {
  background-color: #e2e3e5;
  color: #6c757d;
  font-weight: bold;
  text-align: center;
  padding: 5px;
  border-radius: 4px;
}
/* Ensures text is truncated */
.reason-cell {
  max-width: 150px; /* Adjust width as needed */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer; /* Show pointer on hover */
}

/* Optional: Add a tooltip effect */
.reason-cell:hover {
  position: relative;
}

.reason-cell:hover::after {
  content: attr(title); /* Show full text */
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  white-space: normal;
  width: 200px; /* Adjust width */
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}
/* Truncate text and show tooltip on hover */
.tooltip-cell {
  max-width: 150px; /* Adjust width */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer; /* Show pointer on hover */
}

/* Tooltip effect */
.tooltip-cell:hover {
  position: relative;
}

.tooltip-cell:hover::after {
  content: attr(title); /* Show full text */
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  white-space: normal;
  max-width: 250px; /* Adjust width */
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

@media (max-width: 768px) 
{
  .empleavetracker-container {
    overflow-x: auto;
    padding: 30px;
    width: 88%;
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MyEmpDashboard/EmpLeaveTracker.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;;AAEpB;AACA;EACE;IACE,iBAAiB,EAAE,sCAAsC;EAC3D;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;;EAEd,kBAAkB;EAClB,gBAAgB;;CAEjB,cAAc;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;;CAEjB,cAAc;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;;CAEjB,cAAc;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA,8BAA8B;AAC9B;EACE,gBAAgB,EAAE,2BAA2B;EAC7C,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe,EAAE,0BAA0B;AAC7C;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB,EAAE,mBAAmB;EACzC,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY,EAAE,iBAAiB;EAC/B,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;AACb;AACA,4CAA4C;AAC5C;EACE,gBAAgB,EAAE,iBAAiB;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe,EAAE,0BAA0B;AAC7C;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB,EAAE,mBAAmB;EACzC,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB,EAAE,iBAAiB;EACnC,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;AACb;;AAEA;;EAEE;IACE,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,aAAa;EACf;AACF","sourcesContent":["/* Employee Leave Tracker Styles */\n.empleavetracker-container {\n  width: 100%;\n  margin: 20px auto;\n  font-family: Arial, sans-serif;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.empleavetracker-header {\n  background-color: white;\n  color: black;\n  text-align: left;\n  font-size: 20px;\n  padding: 10px;\n  font-weight: bold;\n}\n\n.empleavetracker-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.empleavetracker-table th,\n.empleavetracker-table td {\n  border: 1px solid #ddd;\n  padding: 10px;\n  text-align: center;\n  \n}\n@media (min-width: 1200px) {\n  .empleavetracker-container {\n    max-width: 1100px; /* Limit max width on larger screens */\n  }\n}\n.empleavetracker-table th {\n  background-color: #bebdbd;\n  color: black;\n}\n\n.empleavetracker-table tbody tr {\n  background-color: white;\n}\n\n.empleavetracker-status-approved {\n  background-color: #d7f2ce;\n  color: #155724;\n\n  text-align: center;\n  padding: 6px 6px;\n \n display: block;\n  border-radius: 20px;\n  min-width: 80px;\n}\n\n.empleavetracker-status-rejected {\n  background-color: #ffe5d2;\n  color: #721c24;\n  text-align: center;\n  padding: 6px 6px;\n \n display: block;\n  border-radius: 20px;\n  min-width: 80px;\n}\n\n.empleavetracker-status-pending {\n  background-color: #fff3cd;\n  color: #856404;\n  text-align: center;\n  padding: 6px 6px;\n \n display: block;\n  border-radius: 20px;\n  min-width: 80px;\n}\n\n.empleavetracker-status-default {\n  background-color: #e2e3e5;\n  color: #6c757d;\n  font-weight: bold;\n  text-align: center;\n  padding: 5px;\n  border-radius: 4px;\n}\n/* Ensures text is truncated */\n.reason-cell {\n  max-width: 150px; /* Adjust width as needed */\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer; /* Show pointer on hover */\n}\n\n/* Optional: Add a tooltip effect */\n.reason-cell:hover {\n  position: relative;\n}\n\n.reason-cell:hover::after {\n  content: attr(title); /* Show full text */\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: #fff;\n  padding: 5px;\n  border-radius: 4px;\n  white-space: normal;\n  width: 200px; /* Adjust width */\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n}\n/* Truncate text and show tooltip on hover */\n.tooltip-cell {\n  max-width: 150px; /* Adjust width */\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer; /* Show pointer on hover */\n}\n\n/* Tooltip effect */\n.tooltip-cell:hover {\n  position: relative;\n}\n\n.tooltip-cell:hover::after {\n  content: attr(title); /* Show full text */\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: #fff;\n  padding: 5px;\n  border-radius: 4px;\n  white-space: normal;\n  max-width: 250px; /* Adjust width */\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n}\n\n@media (max-width: 768px) \n{\n  .empleavetracker-container {\n    overflow-x: auto;\n    padding: 30px;\n    width: 88%;\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
